module.exports = __webpack_public_path__ + "static/media/ico-new-causas.00c6090d.svg";